import { ChevronsUpDown } from 'lucide-react';
import {
  Avatar,
  AvatarFallback,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@predoc/cow';

interface NavUserSkeletonProps {
  className?: string;
}

export const NavUserSkeleton = ({ className }: NavUserSkeletonProps) => {
  return (
    <SidebarMenu className={className}>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg" className="w-full animate-pulse">
          <Avatar className="h-8 w-8 rounded-lg">
            <AvatarFallback className="bg-gray-200">
              <div className="h-4 w-4 rounded bg-gray-300"></div>
            </AvatarFallback>
          </Avatar>
          <div className="grid flex-1 text-left text-sm leading-tight">
            <div className="h-4 w-24 rounded bg-gray-200"></div>
            <div className="mt-1 h-3 w-32 rounded bg-gray-200"></div>
          </div>
          <ChevronsUpDown className="ml-auto size-4 text-gray-300" />
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};
